import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useReviews, useReviewsHistogram } from '@marageti/z4-lib';
import UseInfiniteScroll from 'react-infinite-scroll-hook';
import ReviewsView from './reviews-view';

const ReviewsContainer = () => {
  const { partnerId } = useParams<{ partnerId: string }>();
  const [selectedRatingFilter, setSelectedRatingFilter] = useState<number | undefined>();
  const { histogramAggregation, loading: loadingHistogram, error: errorHistogram } = useReviewsHistogram({ partnerId });
  const {
    reviews, loading: loadingReviews, error: errorReviews, loadMore: loadMoreReviews, hasNextPage,
  } = useReviews({ searchItemId: partnerId, searchItemFieldName: 'partnerId', rating: selectedRatingFilter });

  const [sentryRef] = UseInfiniteScroll({
    disabled: !!errorReviews || !!errorHistogram,
    loading: loadingReviews,
    hasNextPage,
    onLoadMore: loadMoreReviews,
  });

  const handleRatingHistogramOnSelect = (newRatingFilter: number) => {
    setSelectedRatingFilter((previousRatingFilter: number | undefined) => (previousRatingFilter === newRatingFilter ? undefined : newRatingFilter));
  };

  const clearFilter = () => (setSelectedRatingFilter(undefined));

  return (
    <ReviewsView
      histogramAggregation={histogramAggregation}
      loadingHistogram={loadingHistogram}
      errorHistogram={errorHistogram}
      onHistogramSelect={handleRatingHistogramOnSelect}
      reviews={reviews}
      errorReviews={errorReviews || errorHistogram}
      sentryRef={sentryRef}
      hasNextPage={hasNextPage}
      selectedRatingFilter={selectedRatingFilter}
      clearFilter={clearFilter}
    />
  );
};

export default ReviewsContainer;
